// import _ from 'lodash';
import debug from '../../services/debug';
import {
  SET_CONTACTID_ROUTE_REQUESTED,
  // SET_CONTACT_REDIRECT_ABORTED,
  SET_CONTACTID_ROUTE_COMPLETED,
  SET_CONTACTID_ROUTE_FAILED,
} from './types';

const setContactIDRoute = async (ContactID) => async (dispatch) => {
  // const { contacts } = getState();

  // const contact = contacts.get('set');
  // if (_.isEmpty(contact) && contact.ContactID === 0) {
  //     return dispatch({
  //         type: SET_CONTACT_REDIRECT_ABORTED,
  //     });
  // }

  dispatch({
    type: SET_CONTACTID_ROUTE_REQUESTED,
  });

  try {
    dispatch({
      type: SET_CONTACTID_ROUTE_COMPLETED,
      payload: ContactID,
    });
  } catch (err) {
    debug(SET_CONTACTID_ROUTE_FAILED, err);

    dispatch({
      type: SET_CONTACTID_ROUTE_FAILED,
      payload: err,
    });
  }
};

export default setContactIDRoute;
